import validate from "/usr/src/app/content/n3-packages-1c60ef52-a6d5-48b9-9783-f6c24fea1cbe/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-1c60ef52-a6d5-48b9-9783-f6c24fea1cbe/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}